import { FC } from "react";
import { useAuth } from "../auth/authContext";

export const Account: FC = () => {
  const { roles, currentUser } = useAuth();

  return (
    <div>
      <h4>Account</h4>
      {currentUser && <p className="text-muted">{currentUser.email}</p>}

      <h5 className="mt-4">Permissions</h5>
      {roles.length > 0 ? (
        <ul>
          {roles.map((r, i) => (
            <li key={i}>{r}</li>
          ))}
        </ul>
      ) : (
        <div className="alert alert-warning">
          <h6>You've not yet been set up with any permissions.</h6>
          <p className="mb-0">
            Please contact your representative and ask to be set up.
          </p>
        </div>
      )}
    </div>
  );
};
